import {SortSchema, validatePhone} from '@cypro/ui/schemas'
import {
  AddApplicationFormSchema,
  AddBasicDataItemSchema,
  AddGeneralPhysicianSchema,
  AddInsuranceCompanySchema,
  AddMedicineFormSchema,
} from '@cypro/engine/mutators'
import * as z from 'zod'

export const BasicDataFormSchema = AddBasicDataItemSchema
export type BasicDataFormSchema = z.infer<typeof BasicDataFormSchema>

export const MedicineFormSchema = AddMedicineFormSchema
export type MedicineFormSchema = z.infer<typeof MedicineFormSchema>

export const ApplicationFormSchema = AddApplicationFormSchema
export type ApplicationFormSchema = z.infer<typeof ApplicationFormSchema>

export const InsuranceCompanyFormSchema = AddInsuranceCompanySchema
export type InsuranceCompanyFormSchema = z.infer<typeof InsuranceCompanyFormSchema>

export const GeneralPhysicianFormSchema = AddGeneralPhysicianSchema.omit({phone: true}).extend({
  phone: validatePhone({required: false}),
})
export type GeneralPhysicianFormSchema = z.infer<typeof GeneralPhysicianFormSchema>

export const BasicDataSearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})
